export const checkLower = (loan: string, limit: string) =>
  parseInt(loan, 10) > parseInt(limit, 10);

export const checkUpper = (loan: string, limit: string) =>
  parseInt(loan, 10) < parseInt(limit, 10);
